import { AppEnvironment } from '../app/core/models/environment.models';

export const environment: AppEnvironment = {
  production: false,
  version: '1.0.0-dev',
  projectName: 'Os Fogóns do Anllóns',
  // apiBaseUrl: 'http://localhost:8000/api/v1',
  apiBaseUrl: 'https://dev.cms.osfogonsdoanllons.com/api/v1',
  googleMapsApiKey: 'AIzaSyBsg5mA0cajNE_PF4MpYOX3K2193jzr45E',
  googleMapsMapId: 'dc1818698f24815e653b09ed',
  auth: {
    enabled: true,
    requireLogin: true,
    enforcePermissions: true,
    loginField: 'email',
  },
  zones: {
    enabled: false,
  },
};
